export const BURTON_VARIANT_STORAGE_KEY = 'burton_dashboard_variant'

/** @typedef {'iap' | 'official'} BurtonDashboardVariant */

/** @type {BurtonDashboardVariant} */
export const BURTON_VARIANT_IAP = 'iap'

/** @type {BurtonDashboardVariant} */
export const BURTON_VARIANT_OFFICIAL = 'official'

const VALID_VARIANTS = new Set([BURTON_VARIANT_IAP, BURTON_VARIANT_OFFICIAL])

/**
 * @returns {BurtonDashboardVariant | null}
 */
export function getLastBurtonDashboardVariant() {
  try {
    const raw = localStorage.getItem(BURTON_VARIANT_STORAGE_KEY)
    if (raw && VALID_VARIANTS.has(raw)) {
      return /** @type {BurtonDashboardVariant} */ (raw)
    }
  } catch {
    /* ignore */
  }
  return null
}

/**
 * @param {BurtonDashboardVariant} variant
 */
export function setLastBurtonDashboardVariant(variant) {
  if (!VALID_VARIANTS.has(variant)) return
  try {
    localStorage.setItem(BURTON_VARIANT_STORAGE_KEY, variant)
  } catch {
    /* ignore */
  }
}

/**
 * @param {BurtonDashboardVariant} variant
 * @returns {string}
 */
export function getBurtonDashboardRoute(variant) {
  return variant === BURTON_VARIANT_OFFICIAL
    ? '/burton-dashboard/official'
    : '/burton-dashboard/iap'
}
